import React from 'react';
import './CaseStudyPage.css'
import Header from '../components/Header/Header';
import Interview from '../components/Interview/Interview';

const InterviewPage = () => {
   return(
    <>
      <Header />
      <Interview />
    </>
   )
};

export default InterviewPage;
